import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;
const isProd = import.meta.env.PROD;
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const tunnel =
  import.meta.env.VITE_SENTRY_TUNNEL ||
  (supabaseUrl ? `${supabaseUrl}/functions/v1/sentry-tunnel` : undefined);

if (dsn && isProd) {
  Sentry.init({
    dsn,
    ...(tunnel && { tunnel }),
    debug: false,
    enableLogs: true,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
    tracePropagationTargets: [/^\//, /localhost/, /lizta\./],
    replaysSessionSampleRate: import.meta.env.PROD ? 0.1 : 0,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: false,
  });
}
